import React from "react";
import useHeaderDataStatus from "../../../../components/hooks/useHeaderDataStatus";
import { MdOutlineCheck } from "react-icons/md";
import { IoCloseOutline } from "react-icons/io5";
import WrapperLoader from "../../../../components/spinner/WrapperLoader";

function ClientEda({ scriptPresentData, scriptPresentDataIsLoading }) {
  const isClientEdaFound =
    scriptPresentData?.files?.["client_eda.py"]?.file_name;
  return (
    <div
      title={!isClientEdaFound && "Script is missing"}
      className={
        scriptPresentDataIsLoading
          ? "text-gray-400"
          : !isClientEdaFound && "text-red-400"
      }
    >
      Client EDA
      <WrapperLoader isLoading={scriptPresentDataIsLoading}></WrapperLoader>
      {/* <div className="flex justify-center">
        <WrapperLoader isLoading={scriptPresentDataIsLoading}>
          {isClientEdaFound ? (
            <MdOutlineCheck color="green" size={16} />
          ) : (
            <IoCloseOutline color="red" size={16} />
          )}
        </WrapperLoader>
      </div> */}
    </div>
  );
}

export default ClientEda;
